module.exports = __webpack_public_path__ + "img/name_calc.5e1a4291.jpg";